// Mirrors firebase/functions/src/libs/libSldAdmin.js.
//
// SLD staff administer every customer company, including ones they are not a
// member of — a customer with separate test and production company docs is the
// usual case. Widening one side without the other is how a button ends up
// offering an action the backend then refuses with 403, so keep the two in
// step (the Lao gates hold a third copy in libs/libLaoAuth.js).
const ADMIN_EMAIL_DOMAIN = '@sala-daeng.com'

/**
 * @param {Object} userData    Users/{uid} doc — state.user.userData
 * @param {Object} userCompany CompaniesUsers/{company}_{uid} — may be empty
 * @returns {Boolean}
 */
export default function isSldAdmin(userData, userCompany) {
  if (!userData) return false

  const email = (userData.email || '').toString().toLowerCase()
  if (email.endsWith(ADMIN_EMAIL_DOMAIN)) return true
  if (userData.isEngineer === true) return true

  return !!(userCompany && userCompany.isDeveloper === true)
}
